// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"591":"bb059d67","822":"842aa21d","837":"ca963dd4","915":"527c84de"}[chunkId] + ".css";
};